var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCompliance(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 200,
    height: 200,
    viewBox: "0 0 200 200",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M100 165C135.899 165 165 135.899 165 100C165 64.1015 135.899 35 100 35C64.1015 35 35 64.1015 35 100C35 135.899 64.1015 165 100 165Z",
    fill: "#EEEEEE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M154.033 55.6068C154.033 53.0601 151.967 51 149.427 51H59.6067C57.0667 51 55 53.0601 55 55.6068V166.153C55 168.693 57.0667 170.76 59.6067 170.76H149.427C151.967 170.76 154.033 168.693 154.033 166.153V125.707V123.813V55.6068ZM144.82 133.907V161.547H64.2133V60.2134H144.82V131.313V133.907Z",
    fill: "#AEAEAE"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M139.82 55.3932H59.2133V156.727H139.82V55.3932Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M149.033 50.7933C149.033 48.2466 146.967 46.1865 144.427 46.1865H54.6067C52.0667 46.1865 50 48.2466 50 50.7933V161.34C50 163.88 52.0667 165.947 54.6067 165.947H144.427C146.967 165.947 149.033 163.88 149.033 161.34V120.893V119V50.7933ZM139.82 129.093V156.733H59.2133V55.3999H139.82V126.5V129.093Z",
    fill: "#36A635"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M149.033 94.5465V161.333C149.033 163.88 146.973 165.94 144.427 165.94H54.6067C52.06 165.94 50 163.88 50 161.333V50.7866C50 48.2399 52.06 46.18 54.6067 46.18H77.0933",
    stroke: "#4D4D4D",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M119.627 46.1865H144.427C146.973 46.1865 149.033 48.2466 149.033 50.7933V94.5532",
    stroke: "#4D4D4D",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M139.82 103.76V156.727H59.2133V55.3932H75.3333",
    stroke: "#4D4D4D",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M121.393 55.3932H139.82V103.76",
    stroke: "#4D4D4D",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M114.486 43.8799H107.58C107.58 38.7932 103.453 34.6667 98.3665 34.6667C93.2799 34.6667 89.1532 38.7932 89.1532 43.8799H82.2465C78.4332 43.8799 75.3398 46.9733 75.3398 50.7866V57.6932H121.4V50.7866C121.4 46.9733 118.306 43.8799 114.493 43.8799H114.486Z",
    fill: "white",
    stroke: "#4D4D4D",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M98.3666 41.5798V46.1864",
    stroke: "#4D4D4D",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M98.3666 76.1266H121.393",
    stroke: "#4D4D4D",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M98.3666 85.3333H112.18",
    stroke: "#4D4D4D",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M98.3666 101.453H121.393",
    stroke: "#4D4D4D",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M98.3666 110.667H112.18",
    stroke: "#4D4D4D",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M98.3666 136H112.18",
    stroke: "#4D4D4D",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M98.3666 126.787H116.787",
    stroke: "#4D4D4D",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M85.1666 89.6133H76.1C73.74 89.6133 71.8199 87.6933 71.8199 85.3333V76.2666C71.8199 73.9066 73.74 71.9867 76.1 71.9867H85.1666C87.5266 71.9867 89.4467 73.9066 89.4467 76.2666V85.3333C89.4467 87.6933 87.5266 89.6133 85.1666 89.6133ZM76.1 75.5332C75.6933 75.5332 75.3667 75.8666 75.3667 76.2666V85.3333C75.3667 85.74 75.6933 86.0666 76.1 86.0666H85.1666C85.5733 86.0666 85.8999 85.74 85.8999 85.3333V76.2666C85.8999 75.8599 85.5733 75.5332 85.1666 75.5332H76.1Z",
    fill: "#36A635"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M87.1399 74.3264C86.7532 73.9398 86.2199 73.733 85.6799 73.7464C85.1332 73.753 84.6199 73.9863 84.2532 74.393L82.7132 76.093L82.3065 76.5397L80.9132 78.073L79.4732 79.6598C79.4265 79.7131 79.3799 79.7531 79.3265 79.7931C79.1865 79.8931 79.0199 79.9464 78.8399 79.9531C78.5999 79.9597 78.3799 79.8663 78.1999 79.693L77.5599 79.053C76.7799 78.273 75.5065 78.273 74.7198 79.0597C74.3398 79.4397 74.1332 79.9398 74.1332 80.4731C74.1332 81.0064 74.3398 81.513 74.7198 81.893L77.4199 84.593C77.4799 84.653 77.5533 84.7197 77.6266 84.7731C77.7866 84.9064 77.9732 84.9997 78.1665 85.0664C78.3732 85.1464 78.5999 85.1798 78.8332 85.1798H78.8733C79.4199 85.1665 79.9332 84.9397 80.2998 84.5397L87.2066 77.0997C87.9399 76.3064 87.9132 75.0864 87.1532 74.3198L87.1399 74.3264ZM80.7265 79.9331L80.6332 80.033C80.6798 79.9663 80.7266 79.8864 80.7666 79.8064C80.7599 79.8531 80.7465 79.8931 80.7265 79.9331Z",
    fill: "#4D4D4D"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M85.1666 114.407H76.1C73.74 114.407 71.8199 112.487 71.8199 110.127V101.06C71.8199 98.6999 73.74 96.7799 76.1 96.7799H85.1666C87.5266 96.7799 89.4467 98.6999 89.4467 101.06V110.127C89.4467 112.487 87.5266 114.407 85.1666 114.407ZM76.1 100.327C75.6933 100.327 75.3667 100.66 75.3667 101.06V110.127C75.3667 110.533 75.6933 110.86 76.1 110.86H85.1666C85.5733 110.86 85.8999 110.533 85.8999 110.127V101.06C85.8999 100.653 85.5733 100.327 85.1666 100.327H76.1Z",
    fill: "#36A635"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M87.1399 99.1201C86.7532 98.7334 86.2199 98.5267 85.6799 98.54C85.1332 98.5467 84.6199 98.78 84.2532 99.1867L82.7132 100.887L82.3065 101.333L80.9132 102.867L79.4732 104.453C79.4265 104.507 79.3799 104.547 79.3265 104.587C79.1865 104.687 79.0199 104.74 78.8399 104.747C78.5999 104.753 78.3799 104.66 78.1999 104.487L77.5599 103.847C76.7799 103.067 75.5065 103.067 74.7198 103.853C74.3398 104.233 74.1332 104.733 74.1332 105.267C74.1332 105.8 74.3398 106.307 74.7198 106.687L77.4199 109.387C77.4799 109.447 77.5533 109.513 77.6266 109.567C77.7866 109.7 77.9732 109.793 78.1665 109.86C78.3732 109.94 78.5999 109.973 78.8332 109.973H78.8733C79.4199 109.96 79.9332 109.733 80.2998 109.333L87.2066 101.893C87.9399 101.1 87.9132 99.8801 87.1532 99.1134L87.1399 99.1201ZM80.7265 104.727L80.6332 104.827C80.6798 104.76 80.7266 104.68 80.7666 104.6C80.7599 104.647 80.7465 104.687 80.7265 104.727Z",
    fill: "#4D4D4D"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M85.46 139.967H76.3932C74.0332 139.967 72.1133 138.047 72.1133 135.687V126.62C72.1133 124.26 74.0332 122.34 76.3932 122.34H85.46C87.82 122.34 89.7399 124.26 89.7399 126.62V135.687C89.7399 138.047 87.82 139.967 85.46 139.967ZM76.3932 125.887C75.9866 125.887 75.6599 126.22 75.6599 126.62V135.687C75.6599 136.093 75.9866 136.42 76.3932 136.42H85.46C85.8666 136.42 86.1933 136.093 86.1933 135.687V126.62C86.1933 126.213 85.8666 125.887 85.46 125.887H76.3932Z",
    fill: "#36A635"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M87.4266 124.673C87.0399 124.287 86.5066 124.08 85.9666 124.093C85.4199 124.1 84.9066 124.333 84.54 124.74L82.9999 126.44L82.5933 126.887L81.2 128.42L79.7599 130.007C79.7133 130.06 79.6666 130.1 79.6133 130.14C79.4733 130.24 79.3066 130.293 79.1266 130.3C78.8866 130.307 78.6666 130.213 78.4866 130.04L77.8466 129.4C77.0666 128.62 75.7933 128.62 75.0066 129.407C74.6266 129.787 74.4199 130.287 74.4199 130.82C74.4199 131.353 74.6266 131.86 75.0066 132.24L77.7066 134.94C77.7666 135 77.8399 135.067 77.9132 135.12C78.0732 135.253 78.26 135.347 78.4533 135.413C78.66 135.493 78.8866 135.527 79.12 135.527H79.1599C79.7066 135.513 80.2199 135.287 80.5866 134.887L87.4932 127.447C88.2266 126.653 88.1999 125.433 87.4399 124.667L87.4266 124.673ZM81.0133 130.28L80.9199 130.38C80.9666 130.313 81.0132 130.233 81.0532 130.153C81.0466 130.2 81.0333 130.24 81.0133 130.28Z",
    fill: "#4D4D4D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCompliance);
export default __webpack_public_path__ + "static/media/Compliance.3e810a7304bcb5fb9823da0709863fd3.svg";
export { ForwardRef as ReactComponent };